export default {
    ENTRADA: 1,
    RETORNO: 2,
    TRATAMENTO: 3,
    REABILITACAO: 4,
    ALTA: 5,
    ENTRADA_ALTA: 6,
}